import { RuleTypeEnum } from "../../../domain/RuleType";
import { WebHostnameRuleValue } from "../../../domain/ruleValue/WebHostnameRuleValue";
import { RuleValueStore, SerializedRuleValueStore } from "../RuleValueStore";

export class WebHostnameRuleValueStore implements RuleValueStore<RuleTypeEnum.WEB_HOSTNAME> {
    allowedHostnames: Set<string>;
    deniedHostnames: Set<string>;

    constructor() {
        this.allowedHostnames = new Set();
        this.deniedHostnames = new Set();
    }

    add(ruleValue: WebHostnameRuleValue): void {
        if (ruleValue.action.isAllow()) {
            this.allowedHostnames.add(ruleValue.getValue().webHostname);
        } else {
            this.deniedHostnames.add(ruleValue.getValue().webHostname);
        }
    }

    serialize(): SerializedRuleValueStore<RuleTypeEnum.WEB_HOSTNAME> {
        const data: SerializedWebHostnameRuleValueStoreData = {
            allowedHostnames: Array.from(this.allowedHostnames),
            deniedHostnames: Array.from(this.deniedHostnames),
        };
        return {
            type: RuleTypeEnum.WEB_HOSTNAME,
            data: data,
        };
    }

    fromSerialized(serialized: SerializedRuleValueStore<RuleTypeEnum.WEB_HOSTNAME>): void {
        this.allowedHostnames = new Set(serialized.data.allowedHostnames);
        this.deniedHostnames = new Set(serialized.data.deniedHostnames);
    }

    evaluateWebHostname(hostname: string): WebHostnameRuleValueStoreEvaluationResult {
        const splittedHostname: string[] = hostname.split(".").reverse();
        if (splittedHostname.length < 2) return "NO_MATCH";
        const tld: string = splittedHostname.shift()!;

        // Check whitelist (considering subdomains)
        let subHostname: string = tld;
        for (const hostnamePart of splittedHostname) {
            subHostname = hostnamePart + "." + subHostname;
            if (this.allowedHostnames.has(subHostname)) return "ALLOWED";
        }

        // Check blacklist (considering subdomains)
        subHostname = tld;
        for (const hostnamePart of splittedHostname) {
            subHostname = hostnamePart + "." + subHostname;
            if (this.deniedHostnames.has(subHostname)) return "DENIED";
        }

        return "NO_MATCH";
    }
}

export interface SerializedWebHostnameRuleValueStoreData {
    allowedHostnames: string[];
    deniedHostnames: string[];
};

export type WebHostnameRuleValueStoreEvaluationResult = "ALLOWED" | "DENIED" | "NO_MATCH";